// extracted by mini-css-extract-plugin
export var currentStep = "_m2-2";
export var nodeCard = "_m2-0";
export var pathHighlighted = "_m2-1";